import type { DataAdapter } from '../types/adapter';
import type { PullResult, GachaSession } from '../types/pack';
import { resolveGuaranteeRarity } from './rarity';

export async function pull(
  adapter: DataAdapter,
  session: GachaSession,
  collection: string[],
  dailyLimit = 10,
  options?: {
    excludeIds?: string[];
  }
): Promise<PullResult> {
  if (session.pullsToday >= dailyLimit) {
    throw new Error('DAILY_LIMIT_REACHED');
  }

  const guaranteeRarity = resolveGuaranteeRarity(session);
  const card = await adapter.pullRandom({
    guaranteeRarity,
    excludeIds: options?.excludeIds ?? []
  });

  const updatedSession: GachaSession = {
    pullsToday: session.pullsToday + 1,
    pullsSinceLegendary: card.rarity === 'legendary' ? 0 : session.pullsSinceLegendary + 1,
    pullsSinceEpic: ['legendary', 'epic'].includes(card.rarity) ? 0 : session.pullsSinceEpic + 1
  };

  return {
    card,
    isNew: !collection.includes(card.id),
    session: updatedSession
  };
}
